import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Box } from '@livable/saas-react-components';
import { Container } from '@mui/material';
import { BuildingsTable } from 'src/components/property/BuildingsTable';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { ActionsBar } from './ActionsBar';
import { EmptyState } from './EmptyState';
import { Saver } from './Saver';
import InformationBanner from 'src/components/shared/InformationBanner';
import BuildingsTableLoader from './BuildingsTableLoader';
import useStyles from './styles';
import WelcomeModal from 'src/components/shared/Welcome';
export const DashboardPage = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const companyId = localStorage.getItem(USER_SETTINGS_KEYS.company);
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    dashboardCharts = _useState4[0],
    setDashboardCharts = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataIsReady = _useState6[0],
    setDataIsReady = _useState6[1];
  const getCurrentCycle = async data => {
    const resp = await store.allocations.getCurrentCycleAsync.run(data);
    return resp;
  };
  const getPropertiesDashboard = async data => {
    const resp = await store.properties.getPropertiesDashboardAsync.run(data);
    return resp;
  };
  const getDashboardCharts = async data => {
    const resp = await store.properties.getDashboardChartsAsync.run(data);
    return resp;
  };
  const getNotifications = async () => {
    const resp = await store.notifications.getPendingNotificationsAsync.run();
    return resp;
  };
  const handleCross = async data => {
    const newNotifications = [...notifications];
    const cNotificationIndex = newNotifications.findIndex(i => i.id === data);
    newNotifications.splice(cNotificationIndex, 1);
    setNotifications(newNotifications);
    await store.notifications.acknowledgementNotificationAsync.run({
      notificationId: data
    });
  };
  useEffect(() => {
    if (!localStorage.getItem('livable_portfolio_id')) {
      setDataIsReady(true);
      return;
    } else {
      Promise.all([getCurrentCycle({
        companyId
      }), getPropertiesDashboard({
        portfolioId: localStorage.getItem('livable_portfolio_id')
      }), getNotifications()]).then(async resp => {
        var _resp$;
        if (!resp) {
          return;
        }
        try {
          await store.properties.getResidentTipsAsync.run();
        } catch (error) {}
        if ((_resp$ = resp[2]) !== null && _resp$ !== void 0 && (_resp$ = _resp$.response) !== null && _resp$ !== void 0 && _resp$.length) {
          setNotifications(resp[2].response);
          resp[2].response.map(async item => {
            if (item.appearanceType === 'TermsOfServicesModal') return;
            await store.notifications.viewNotificationAsync.run({
              notificationId: item.id
            });
          });
        }
        const dashboardChartsRes = await getDashboardCharts({
          portfolioId: localStorage.getItem('livable_portfolio_id')
        });
        setDashboardCharts(dashboardChartsRes);
        setDataIsReady(true);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, dataIsReady && store.properties.allPropertyList.length !== 0 && !(store.properties.allPropertyList.length === 1 && store.properties.allPropertyList[0].isDemo && localStorage.getItem('livable_demo_mode') !== 'Demo') && /*#__PURE__*/React.createElement(Box, {
    className: classes.topSectionWrapper
  }, /*#__PURE__*/React.createElement(Container, null, notifications.map(item => {
    if (item.appearanceType !== 'Banner') return;
    return /*#__PURE__*/React.createElement(InformationBanner, {
      type: item.notificationType.toLocaleLowerCase(),
      title: item.title,
      text: item.body,
      btnLink: item.showButton ? item.buttonUrl : null,
      btnTitle: item.showButton ? item.buttonTitle : null,
      handleCross: () => handleCross(item.id)
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.saverDesktop
  }, /*#__PURE__*/React.createElement(Saver, {
    tips: store.properties.propertyTipsList
  })))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, {
    className: classes.pageWrapper
  }, !dataIsReady && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(BuildingsTableLoader, null))), dataIsReady && dashboardCharts.length > 0 && store.properties.allPropertyList.length > 0 && !(store.properties.allPropertyList.length === 1 && store.properties.allPropertyList[0].isDemo && localStorage.getItem('livable_demo_mode') !== 'Demo') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActionsBar, null), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(BuildingsTable, {
    buildingsData: store.properties.allPropertyList
  }))), dataIsReady && (store.properties.allPropertyList.length === 0 || store.properties.allPropertyList.length === 1 && store.properties.allPropertyList[0].isDemo && localStorage.getItem('livable_demo_mode') !== 'Demo') && /*#__PURE__*/React.createElement(EmptyState, null)), /*#__PURE__*/React.createElement(WelcomeModal, null)));
});